/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderDiscountOperator = {
    ANY: 'ANY',
    ALL: 'ALL'
} as const;
export type OrderDiscountOperator = typeof OrderDiscountOperator[keyof typeof OrderDiscountOperator];


export function instanceOfOrderDiscountOperator(value: any): boolean {
    for (const key in OrderDiscountOperator) {
        if (Object.prototype.hasOwnProperty.call(OrderDiscountOperator, key)) {
            if (OrderDiscountOperator[key as keyof typeof OrderDiscountOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderDiscountOperatorFromJSON(json: any): OrderDiscountOperator {
    return OrderDiscountOperatorFromJSONTyped(json, false);
}

export function OrderDiscountOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountOperator {
    return json as OrderDiscountOperator;
}

export function OrderDiscountOperatorToJSON(value?: OrderDiscountOperator | null): any {
    return value as any;
}

export function OrderDiscountOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderDiscountOperator {
    return value as OrderDiscountOperator;
}

